import { render } from "./joinProxy.vue?vue&type=template&id=2f7a348e&scoped=true"
import script from "./joinProxy.vue?vue&type=script&lang=js"
export * from "./joinProxy.vue?vue&type=script&lang=js"

import "./joinProxy.vue?vue&type=style&index=0&id=2f7a348e&lang=scss&scoped=true"
import "./joinProxy.vue?vue&type=style&index=1&id=2f7a348e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7a348e"]])

export default __exports__